import React from 'react'

import { Container, ContentHeader, Page } from 'components'
import { SSOCorporateGroupForm } from './components'

const SSOCorporateGroupNew = () => {
  return (
    <Page title="Nova Organização SSO-SAML">
      <Container
        maxWidth={false}
        spacingXl={30}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          menu="Organização SSO-SAML"
          title="Criar"
          subtitle="Nova Organização SSO-SAML"
        />
        <SSOCorporateGroupForm />
      </Container>
    </Page>
  )
}

export default SSOCorporateGroupNew
